import { render } from "./InputButton.vue?vue&type=template&id=96577d5c&scoped=true"
import script from "./InputButton.vue?vue&type=script&lang=js"
export * from "./InputButton.vue?vue&type=script&lang=js"

import "./InputButton.vue?vue&type=style&index=0&id=96577d5c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96577d5c"]])

export default __exports__